module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/recreation route-7c678decf47f37ff6ce588d0f6fc075d.png";